import styled from 'styled-components';

export const PaywallFixedTimerStyles = styled.div`
  body.dark & {
    background-color: #1e0f34;
    border-bottom: 1px solid #e8e8e833;
  }

  background-color: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;

  .local-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }

  .local-button {
    margin-left: 8px;
    border-radius: 70px;
    border: 1px solid #8f5af7;
    background: linear-gradient(180deg, #a77aff 0%, #6d2ceb 100%);
    padding: 10px 30px;
    color: #fff;
    font-size: 17px;
    line-height: 22px;
    font-weight: 600;
  }

  .local-numbers {
    display: flex;
    gap: 8px;
    align-items: flex-start;

    &-number {
      font-size: 28px;
      line-height: 34px;
      font-weight: 700;
      background: linear-gradient(135.59deg, #7f36f3 0%, #ed0d80 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &-semicolon {
      margin-top: 9px;
    }

    &-label {
      text-align: center;
    }
  }
`;
